"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportDetail = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const panel_1 = require("../../../components/panel/panel");
const reporting_styles_1 = require("../reporting-styles");
const data_hook_1 = require("../hook/data-hook");
const report_data_1 = require("./report-data");
const report_input_1 = require("./report-input");
const export_hook_1 = require("../hook/export-hook");
const export_dialog_1 = require("../../export/components/dialog/export-dialog/export-dialog");
function ReportDetail({ definition, ExportDialogComponent = export_dialog_1.ExportDialog, exportTag, }) {
    var _a;
    const intl = react_intl_1.useIntl();
    const classes = reporting_styles_1.useStyles();
    const { generate, loading, source, formRef, resultRef } = data_hook_1.useReportData({
        id: definition === null || definition === void 0 ? void 0 : definition.id,
    });
    const { exportDialogRef, openExportDialog, provideData } = export_hook_1.useReportExports({
        report: source.data,
        definition,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.wrapperDetail },
            (source.loading || loading) && (react_1.default.createElement("div", { className: classes.loaderWrapper },
                react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, className: classes.loader }))),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(panel_1.Panel, { label: intl.formatMessage({
                        id: 'EAS_REPORTING_DETAIL_PANEL_TITLE_REPORT',
                        defaultMessage: 'Report {name}',
                    }, {
                        name: definition !== undefined ? definition.label : '',
                    }), sideBorder: true, className: classes.titlePanel })),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(panel_1.Panel, { label: intl.formatMessage({
                        id: 'EAS_REPORTING_DETAIL_PANEL_TITLE_PARAMETERS',
                        defaultMessage: 'Parametry',
                    }), sideBorder: true, className: classes.inputPanel },
                    react_1.default.createElement(report_input_1.ReportInput, { definition: definition, report: source.data, generate: generate, exportClick: openExportDialog, exportTag: exportTag, formRef: formRef }))),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(panel_1.Panel, { label: intl.formatMessage({
                        id: 'EAS_REPORTING_DETAIL_PANEL_TITLE_DATA',
                        defaultMessage: 'Data',
                    }), sideBorder: true, className: classes.dataPanel },
                    react_1.default.createElement(report_data_1.ReportData, { key: (_a = source.data) === null || _a === void 0 ? void 0 : _a.id, report: source.data, formRef: resultRef })))),
        exportTag != null && (react_1.default.createElement(ExportDialogComponent, { ref: exportDialogRef, tag: exportTag, provideData: provideData }))));
}
exports.ReportDetail = ReportDetail;
//# sourceMappingURL=report-detail.js.map